// React
import React from "react";
// Routing
import * as AppRouting from "appRouting";
// Components
import SideBar_Link from "app/application/ui/sideBars/SideBar_Link";
import SideBar_Category from "app/application/ui/sideBars/SideBar_Category";
// Helpers
import NamingHelper from "common/utils/namingHelper";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./SideBar.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class Category_Products extends React.Component {
    render() {
        let { officeId, currentUrl } = this.props;
        const officeProductItems = [
            React.createElement(SideBar_Link, { key: "link1", text: NamingHelper.productsFeaturedListings, url: AppRouting.productsFeaturedListingsUrl(officeId) }),
            React.createElement(SideBar_Link, { key: "link2", text: NamingHelper.productsSpotlightListings, url: AppRouting.productsSpotlightListingsUrl(officeId) }),
            React.createElement(SideBar_Link, { key: "link3", text: NamingHelper.productsOrderHd, url: AppRouting.productsOrderHdListingsUrl(officeId) }),
            React.createElement(SideBar_Link, { key: "link4", text: NamingHelper.productsFeaturedAgents, url: AppRouting.productsFeaturedAgentsUrl(officeId) })
        ];
        const emptyProductItems = [
            React.createElement(SideBar_Link, { key: "link1", text: null, url: AppRouting.homePath() })
        ];
        const renderProductsCategory = () => {
            if (this.props.officeId) {
                return officeProductItems;
            }
            else if (this.props.agencyId) {
                return emptyProductItems;
            }
            else {
                return emptyProductItems;
            }
        };
        if (!this.props.officeId) {
            return React.createElement("div", null);
        }
        return (React.createElement(SideBar_Category, { text: NamingHelper.products, isExpanded: this.props.isExpanded, headingStyle: styles.linkStyleProducts, headingIcon: "glyphicon glyphicon-tasks", url: AppRouting.productsUrl(officeId), currentUrl: currentUrl }, renderProductsCategory()));
    }
}
